import { classifications } from '@mep/pae-commons';
import { Empty, Select, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const { STUDY_LEVELS_ENUM } = classifications;

const { Option } = Select;

const StudyLevelSelect = ({ value, onChange, ...props }) => {
  const { t } = useTranslation('common');
  
  const onClearHandler = useCallback(() => {
    onChange && onChange(null);
  }, [onChange]);
  
  return (
    <Select
      showSearch={false}
      allowClear={false}
      {...props}
      notFoundContent={<Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>}
      value={value}
      onChange={onChange}
      onClear={onClearHandler}
    >
      {STUDY_LEVELS_ENUM
        .map((element, index) => {
          return <Option key={index} value={element} title={t(`studyLevels.${element}`)}>
            <Tooltip title={t(`studyLevels.${element}`)}>{t(`studyLevels.${element}`)}</Tooltip>
          </Option>;
        })}
    </Select>
  );
};

StudyLevelSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
};

export default memo(StudyLevelSelect);
